var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "37px",
    viewBox: "0 0 36 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "soil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "createneworder",
    transform: "translate(-219.000000, -638.000000)",
    fill: "#535353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samplenumber",
    transform: "translate(152.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soil_card",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soil",
    transform: "translate(66.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-639",
    points: "20.8397059 0 17.2485294 0 17.2485294 3.62745098 20.8397059 3.62745098"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-640",
    points: "29.1996056 5.00279902 26.6606438 2.43819118 24.1216821 5.00279902 26.6606438 7.56740686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-641",
    points: "28.0220588 14.5098039 31.6132353 14.5098039 31.6132353 10.8823529 28.0220588 10.8823529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-642",
    points: "13.9651168 5.00279902 11.426155 2.43819118 8.88719324 5.00279902 11.426155 7.56740686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-643",
    points: "10.0661765 10.8823529 6.475 10.8823529 6.475 14.5098039 10.0661765 14.5098039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88292574,18.1381618 C1.89176103,18.1381618 1.0873375,18.9507108 1.0873375,19.9518873 L1.0873375,33.2519363 L10.0652787,18.1381618 L2.88292574,18.1381618 Z",
    id: "Fill-644"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-645",
    points: "20.8388081 18.1381618 22.6343963 36.2754167 29.8167493 36.2754167 24.4299846 18.1381618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.203514,18.1381618 L28.021161,18.1381618 L36.9991022,33.2519363 L36.9991022,19.9518873 C36.9991022,18.9507108 36.1946787,18.1381618 35.203514,18.1381618",
    id: "Fill-646"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-647",
    points: "8.26969044 36.2754167 15.4520434 36.2754167 17.2476316 18.1381618 13.6564551 18.1381618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8608669,12.6969853 C11.8608669,14.0246324 12.239736,15.2543382 12.8574184,16.3244363 L25.2290213,16.3244363 C25.8467037,15.2543382 26.2255728,14.0246324 26.2255728,12.6969853 C26.2255728,8.69046569 23.0096743,5.44208333 19.0432199,5.44208333 C15.0767654,5.44208333 11.8608669,8.69046569 11.8608669,12.6969853",
    id: "Fill-648"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoil);
export default __webpack_public_path__ + "static/media/soil.bf122aae49ca0103f17a0c358de03b8a.svg";
export { ForwardRef as ReactComponent };